import { render, staticRenderFns } from "./CreatorPostSummary.vue?vue&type=template&id=56dadd5c&"
import script from "./CreatorPostSummary.vue?vue&type=script&lang=js&"
export * from "./CreatorPostSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports